import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import IconArrow from '@white-label-icon/icon-arrow';

type IconPosition = 'left' | 'right';
type ContentPosition = 'top' | 'bottom';


export default /*#__PURE__*/_defineComponent({
  __name: 'toggle-content',
  props: {
    buttonId: { default: '' },
    contentId: { default: '' },
    groupName: { default: '' },
    iconPosition: { default: 'left' },
    contentPosition: { default: 'bottom' },
    isOpen: { type: Boolean, default: false }
  },
  emits: ["toggle"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'toggle', value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { buttonId: string | number, contentId: string | number, groupName: string, iconPosition: IconPosition, contentPosition: ContentPosition, isOpen: boolean };





const showOnPrint = ref(true);

const toggleVisibility = (e: MouseEvent) => {
  const { target } = e;
  if (target instanceof HTMLButtonElement) {
    const EXPANDED_CLASS = 'toggle-content--expanded';
    const parent = target.parentNode as HTMLDivElement;
    const expanded = parent.classList.contains(EXPANDED_CLASS);

    document.querySelectorAll(`.${EXPANDED_CLASS}`).forEach((selector) => {
      if (props.groupName && parent.dataset.group === props.groupName) {
        selector.classList.remove(EXPANDED_CLASS);
      }
    });

    if (expanded) {
      parent.classList.remove(EXPANDED_CLASS);
      emit('toggle', false);
      showOnPrint.value = true;
    } else {
      parent.classList.add(EXPANDED_CLASS);
      emit('toggle', true);
      showOnPrint.value = false;
    }
  }
};

return { __sfc: true,props, emit, showOnPrint, toggleVisibility, IconArrow }
}

})